import { CircularProgress, Grid } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactSVG } from "react-svg";
import api from "../../../../../../api/api";
import imgs from "../../../../../../assets/images/imgs";
import StudentTeacherprofileChatbot from "../../../../../../components/StudentTeacherprofileChatbot";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import StudentDashboardChatbot from "../chatbot/StudentChatbot";
import StudentSuggesionCourseData from "../course/StudentSuggesionCourseData";
import StudentSuggesionTeacherCard from "../course/StudentSuggesionTeacherCard";
import { useNavigate } from "react-router";
import { updateGlobalState } from "../../../../../../state/global/slice";

function SRDSStudentHome({
  removeTeacherActiveChat,
  profileFirstName,
  showTooltip,
  setShowTooltip,
  teacherChat,
  setTeacherChat,
  onClickTeacher,
  activeTeacher,
  handleTeacherClick,
  chatbotTeacherStatus,
  setTeacherchatbotStatus,
  getTeacherActiveChat,
  setTeacherActiveChat,
  setActiveTab,
}) {
  const navigate = useNavigate();
  const globalState = useSelector((state) => state.globalState);
  const dispatch = useDispatch();
  const [TempglobalState, setTempglobalState] = useState("");

  const get_teacher_list = globalState?.get_teacher_list?.data ?? [];

  const [showteacherProfile, setShowteacherProfile] = useState(false); // State to control visibility
  const modalRef = useRef();
  const modalContentRef = useRef(); // Reference to the modal content

  // Function to open the modal
  const openModal = () => {
    setShowteacherProfile(true);
  };

  const toggleteacherProfile = () => {
    setShowteacherProfile(false); // Toggle the visibility state
  };

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalContentRef.current &&
        !modalContentRef.current.contains(event.target)
      ) {
        toggleteacherProfile();
      }
    };

    // Attach the event listener
    if (showteacherProfile) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showteacherProfile]);

  const [search, setSearch] = useState("");
  const serachhandleInputChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    setCurrentPage(1); // Reset to page 1 when search changes
  };
  const changeSubjectFillter = (event) => {
    const selectedSubject = event.target.value;
    setTempglobalState(selectedSubject);
    setCurrentPage(1); // Reset to page 1 when filter changes
  };
  // const statusPriority = (status) => {
  //   switch (status) {
  //     case "Pending":
  //       return 1;
  //     case "Active":
  //       return 2;
  //     default:
  //       return 3;
  //   }
  // };

  const { token } = useAuth();
  const [courses, setCourses] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const itemsPerPage = 12; // Define number of items per page
  // Function to fetch courses using Axios
  const [loading, setLoading] = useState(false); // Add this state to your component

  const fetchCourses = async (page) => {
    try {
      setLoading(true); // Set loading to true before the request
      const response = await api.get(`courses/student/my-courses-dashboard/`, {
        params: {
          page: page,
          search: search,
          filter: TempglobalState,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      });

      const data = response.data;

      setCourses(data.data);
      setLoading(false);
      setTotalPages(
        data.count >= 5
          ? Math.ceil(data.count / itemsPerPage)
          : Math.floor(data.count / itemsPerPage),
      ); // Calculate total pages
      setNextUrl(data.next); // Update next URL
      setPrevUrl(data.previous); // Update previous URL
    } catch (error) {
      console.error("Fetching error:", error);
    } finally {
      setLoading(false); // Set loading to false after the request is completed or if an error occurs
    }
  };

  // Effect to fetch data when currentPage changes
  useEffect(() => {
    fetchCourses(currentPage);
    // }, [currentPage, TempglobalState, search, globalState.student_details]);
  }, [currentPage, search, TempglobalState]);

  useEffect(() => {
    const controller = new AbortController();

    const fetchTeacherList = async () => {
      try {
        const { data } = await api.get("/auth/get-teacher-list/", {
          signal: controller.signal,
          headers: { Authorization: `Token ${token}` },
        });
        if (data.status === 200) updateState("get_teacher_list", data ?? {});
      } catch (error) {
        if (error.name === "CanceledError") return;
        console.error("Failed to fetch teacher list:", error);
      }
    };

    fetchTeacherList();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if(globalState?.student_courses && Array.isArray(globalState?.student_courses) && globalState?.student_courses?.length > 0){
      setCourses(globalState?.student_courses || []);
    }
  }, [globalState?.student_courses]);

  // Function to handle page change
  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };

  const activeCourses =
    globalState?.student_details?.data?.my_courses?.active_courses;

  const assignmentsCount =
    globalState?.student_details?.data?.my_courses?.pending_assignments;
  // // Correct: Creating a copy of the array and then sorting
  // let coursesSortedArray = [];
  // if (Array.isArray(courses) && courses.length) {
  //   coursesSortedArray = [...courses].sort((a, b) => {
  //     return statusPriority(a.status) - statusPriority(b.status);
  //   });
  // }

  
  // Use courses as-is from backend (no sorting) to preserve alternating teacher/course order
  let coursesSortedArray = Array.isArray(courses) ? [...courses] : [];

  // === New: Sequential display logic for courseType === 2 ===
  const serialOrder = ["1", "2", "3", "4", "5"]; // Serial order for sorting

  // Function to get the course to show based on competitive exam type
  function getCourseToShowSequentially(allCourses, examType) {
    if (!Array.isArray(allCourses)) return null;

    // Filter courses where courseType == 2 and competitive_exam matches
    const filtered = allCourses.filter(
      (c) => c.type === 2 && c.competitive_exam === examType,
    );

    // Sort by serialNumber order based on comp_course_serial_no
    filtered.sort(
      (a, b) =>
        serialOrder.indexOf(a.comp_course_serial_no) -
        serialOrder.indexOf(b.comp_course_serial_no),
    );

    // Return the first course which is not completed
    for (const course of filtered) {
      if ((course.status ?? "").toLowerCase() !== "completed") {
        return course;
      }
    }

    // All completed? Return null (nothing to show)
    return null;
  }

  // Get the sequential course to show for SAT and ACT
  const courseType2SATToShow = getCourseToShowSequentially(
    coursesSortedArray,
    "SAT",
  );
  const courseType2ACTToShow = getCourseToShowSequentially(
    coursesSortedArray,
    "ACT",
  );

  // Separate courses NOT of courseType 2 to show normally
  const otherCourses = coursesSortedArray.filter((c) => c.type !== 2);

  return (
    <>
      <div className="studentDashboar-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="studentDashboar-wrapper">
                <h2>Hello {profileFirstName}!</h2>
                <div className="studentDashboar-actives-container">
                  <div
                    className="studentDashboar-actives-folder"
                    onClick={openModal}
                  >
                    <div className="studentDashboar-actives-image">
                      <img src={imgs.png.Teacher_profile} alt="" />
                    </div>
                    <div className="studentDashboar-actives-course-count">
                      <h2>
                        {
                          get_teacher_list.filter(
                            (teacher) =>
                              teacher?.first_course?.course_id !== null,
                          )?.length
                        }
                      </h2>
                      <p>My Teacher</p>
                    </div>
                  </div>
                  {showTooltip && (
                    <div
                      className={`teacher_tooltip ${showTooltip ? "show" : ""}`}
                    >
                      <p>
                        Click on "My Teacher" tab to chat with the teacher's AI.
                      </p>
                      <button
                        onClick={() => setShowTooltip(false)}
                        className="tooltip_btn"
                      >
                        Got it
                      </button>
                      <img
                        src={imgs.png.tooltip_trangle}
                        alt="tooltip trangle"
                        className="tooltip_trangl`e"
                      />
                      `
                    </div>
                  )}
                  <div
                    className="studentDashboar-actives-folder"
                    onClick={() => {
                      navigate("/dashboard/my-courses/active-courses", {
                        state: { activeTab: "active-courses" },
                      });
                      setActiveTab("My Courses");
                    }}
                  >
                    <div className="studentDashboar-actives-image">
                      <img src={imgs.png.Active_course} alt="" />
                    </div>
                    <div className="studentDashboar-actives-course-count">
                      <h2>{activeCourses}</h2>
                      <p>
                        {activeCourses > 1 ? "Active Courses" : "Active Course"}
                      </p>
                    </div>
                  </div>
                </div>

                {/* <h2 className="my-academic-report-title">My Academic Report</h2> */}
                {/* <OverallPerformanceDashboard/> */}

                <div className="studentDashboar-Suggested-Courses-wrapper">
                  <div className="studentDashboar-Suggested-Courses-short-by-filter-container justify-between !px-1">
                    <div className="studentDashboar-Suggested-Courses-short-by-filter-serach-inner-inpuut">
                      <div className="studentDashboar-search-filter">
                        <input
                          type="text"
                          name="search"
                          value={search}
                          onChange={serachhandleInputChange}
                          placeholder="Search courses"
                        />
                        <div className="serach-input-icon">
                          <ReactSVG src={imgs.svg.search} alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="studentDashboar-Suggested-Courses-short-by-filter-section">
                      <div className="studentDashboar-Suggested-Courses-short-by-filter-inner-folder">
                        <span>Filter By :</span>
                        <select
                          className="studentDashboar-course-filter"
                          onChange={changeSubjectFillter}
                        >
                          <option value="">Suggested</option>
                          <option value="English">English</option>
                          <option value="Physics">Physics</option>
                          <option value="Chemistry">Chemistry</option>
                          <option value="Math">Math</option>
                          <option value="Science">Science</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div>
                    {loading && (
                      <Grid
                        height={"50vh"}
                        xs={12}
                        container
                        justifyContent="center"
                        alignItems="center"
                      >
                        <CircularProgress size={80} />
                      </Grid>
                    )}
                  </div>
                  <div className="studentDashboar-Suggested-Courses-container">
                    {loading
                      ? null
                      : coursesSortedArray?.length > 0 && !loading
                        ? coursesSortedArray
                            // Map to components
                            .map((course, index) => {
                              // Render teacher card if card_type is "teacher"
                              if (course.card_type === "teacher") {
                                return (
                                  <StudentSuggesionTeacherCard
                                    key={`teacher-${course.teacher_id}-${index}`}
                                    teacher={course}
                                  />
                                );
                              }
                              // Render course card (original logic unchanged)
                              return (
                              <StudentSuggesionCourseData
                                key={index}
                                course={course}
                                isMarketplace={globalState.enabled_modules?.includes(
                                  "marketplace",
                                )}
                              />
                            );
                            })
                        : null}

                    {/* {loading ? (
                      <Grid
                        height={"50vh"}
                        xs={12}
                        container
                        justifyContent={"center"}
                        alignItems={"center"}
                      >
                        <CircularProgress size={80} />
                      </Grid>
                    ) : ( */}
                    {/* <> */}
                    {/* {courseType2SATToShow && (
                          <StudentSuggesionCourseData
                            key={courseType2SATToShow.id || courseType2SATToShow.course_id || "courseType2"}
                            course={courseType2SATToShow}
                          />
                        )} */}

                    {/* {courseType2ACTToShow && (
                          <StudentSuggesionCourseData
                            key={courseType2ACTToShow.id || courseType2ACTToShow.course_id || "courseType2ACT"}
                            course={courseType2ACTToShow}
                          />
                        )} */}

                    {/* Show other courses normally */}
                    {/* {otherCourses.length > 0 &&
                          otherCourses.map((course, index) => (
                            <StudentSuggesionCourseData
                              key={course.id || course.course_id || index}
                              course={course}
                            />
                          ))} */}

                    {/* Show message if no courses */}
                    {/* {!courseType2SATToShow && !courseType2ACTToShow && otherCourses.length === 0 && (
                          <p>No Courses Found</p>
                        )} */}
                    {/* </> */}
                    {/* )} */}
                  </div>
                  {!loading && coursesSortedArray?.length === 0 && (
                    <div className="no-courses-available-container">
                      <div>No Courses Found</div>
                    </div>
                  )}
                </div>
                <br />
                <Grid xs={12} container justifyContent={"center"}>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    color="primary"
                    hideNextButton={
                      nextUrl === null || currentPage === totalPages
                    } // Disable if no next URL and on the last page
                    hidePrevButton={prevUrl === null || currentPage === 1} // Hide if no previous URL and on the first page
                  />
                </Grid>
                <div className="StudentChatbot-section">
                  {getTeacherActiveChat.map((teacher, index) => (
                    <div key={index}>
                      {chatbotTeacherStatus && (
                        <StudentDashboardChatbot
                          key={index}
                          removeTeacherActiveChat={() =>
                            removeTeacherActiveChat(teacher)
                          }
                          right={index * 30}
                          ai_name={`${teacher.name}`}
                          teacher_id={teacher?.user}
                          courseId={
                            teacher?.first_course
                              ? (teacher?.first_course?.course_id ?? "")
                              : ""
                          }
                          isMinimize={teacher.isMinimized}
                          chatbotStatus={chatbotTeacherStatus}
                          lesson_name={
                            teacher?.first_lesson
                              ? (teacher?.first_lesson?.lesson_name ?? "")
                              : ""
                          }
                          ai_tone={teacher?.ai_tone}
                          ai_avatar={teacher?.ai_avatar}
                          ai_welcome_msg={teacher?.ai_welcome_msg}
                        />
                      )}
                    </div>
                  ))}
                </div>
                {showteacherProfile && (
                  <div
                    ref={modalRef}
                    className="studentDashboar-teacher-popup-section"
                  >
                    <div
                      ref={modalContentRef}
                      className="studentDashboar-teacher-popup-wrapper"
                      data-aos="zoom-in"
                    >
                      <h2 className="studentDashboar-teacher-title">
                        My Teachers
                      </h2>
                      <div
                        className="studentDashboar-teacher-popup-cross-btn"
                        onClick={toggleteacherProfile}
                      >
                        <i class="fa-solid fa-x"></i>
                      </div>
                      <div className="studentDashboar-teacher-popup-main-container">
                        <div className="studentDashboar-teacher-popup-container">
                          {get_teacher_list?.filter(
                            (teacher) =>
                              teacher?.first_course?.course_id !== null,
                          )?.length > 0 ? (
                            get_teacher_list
                              ?.filter(
                                (teacher) =>
                                  teacher?.first_course?.course_id !== null,
                              )
                              ?.map((teacher, index) => (
                                <StudentTeacherprofileChatbot
                                  key={index}
                                  closeTeacherProfile={toggleteacherProfile}
                                  onClickTeacher={() => onClickTeacher(teacher)}
                                  studentDashboar_teacher_image={
                                    teacher.ai_avatar ??
                                    imgs.png.tearcher_profile_image
                                  }
                                  teacherName={teacher.name}
                                  teacherId={teacher?.teacher_id}
                                  teacherTitleValue={teacher?.title}
                                />
                              ))
                          ) : (
                            <p>Please enroll in one of the course.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SRDSStudentHome;
